import { IPageTabProps } from "./Page.types";
import { Main } from "./Page.styled";

export function PageTab({ variant = "panel", children }: IPageTabProps) {
  return (
    <>
      {variant === "free" && <>{children}</>}
      {variant === "panel" && <Main>{children}</Main>}
    </>
  );
}
